/// <reference types="./getChangelogEventsEntityInfo.d.ts" />
import { notOk, ok, } from '@dossierhq/core';
import { createSqliteSqlQuery, } from '@dossierhq/database-adapter';
import { queryNoneOrOne } from '../QueryFunctions.js';
export async function eventGetChangelogEventsEntityInfo(database, context, reference) {
    const { sql, query } = createSqliteSqlQuery();
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    sql `SELECT id, auth_key, resolved_auth_key FROM entities WHERE uuid = ${reference.id}`;
    const result = await queryNoneOrOne(database, context, query);
    if (result.isError())
        return result;
    if (!result.value) {
        return notOk.NotFound('No such entity');
    }
    const { id: entityInternalId, auth_key: authKey, resolved_auth_key: resolvedAuthKey, } = result.value;
    return ok({ entityInternalId, authKey, resolvedAuthKey });
}
//# sourceMappingURL=getChangelogEventsEntityInfo.js.map